import React from "react";
import { CommonModal } from "../../AbstractElements";
import { Row, Col } from "reactstrap";
import { showAlert } from "../../Services/Shared.service";
import { deleteZone, updateZone } from "../../Services/Zone.service";

const DeleteConfirmation = ({ Large, title, LargeModaltoggle, deleteObj, fetchData }) => {
  const onDeleteSubmit = (formValues) => {
    if (deleteObj.isDeleted) {
      const body = {
        id: deleteObj.id,
        serviceCityId: deleteObj.serviceCityId,
        area: deleteObj.area,
        zone: deleteObj.zone,
        isAvailable: deleteObj.isAvailable ,
        isDeleted: false
      };
      updateZone(body)
        .then(async (result) => {
          showAlert('success', "Zone recovered successfully")
          await fetchData()
          LargeModaltoggle();
        })
        .catch((err) => {
          showAlert("error", err.response?.data?.message
            ? err.response.data.message : "Something went wrong");
        });
    } else {
      deleteZone(deleteObj.id).then(async (result) => {
        showAlert('success', "Zone deleted successfully")
        await fetchData()
        LargeModaltoggle();
      }).catch(err => {
        showAlert('error', err.response?.data?.message
          ? err.response.data.message : 'Something went wrong')
      })
    }
  };
  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={LargeModaltoggle}
      size="md"
    >
      <Row className="driver-push-notification">
        <Col xl="12" className="push-botification-body">
          <div className="text-center">Are you sure you want to {deleteObj.isDeleted ? "recover" : "delete"} this zone ?</div>
        </Col>
        <Col xl="12" className="push-notification-footer">
          <button
            className="btn btn-primary"
            type="submit"
            onClick={() => onDeleteSubmit()}
          >
            Confirm
          </button>
        </Col>
      </Row>
    </CommonModal>
  );
};

export default DeleteConfirmation;
